import React from "react";
import "../../Css/GpuManuals.css";
import banner from '../../Assets/background2.JPG'
import Nav from "../../Utils/Nav";
import Footer from "../../Utils/Footer";


const Manuals = () => {
  const gettingStart = [
    `To use Nvidia GPU, you require your account on the server`,

    "The administrator provides the account credentials",

    "Once you get your credentials, you have to ssh to the container (use putty or any other ssh client in case of windows)",

    `Eg:`,

    `ssh username@server ip`,

    `Note: the username and server name /IP is provided by the administrator`,

    `You are provided with sudo access to the container so that you can install your required softwares and libraries.`,
  ];

  const steps = [
    {
      title: "Step 1: Install CUDA 12.4",
      command: `wget https://developer.download.nvidia.com/compute/cuda/repos/ubuntu2204/x86_64/cuda-ubuntu2204.pin
sudo mv cuda-ubuntu2204.pin /etc/apt/preferences.d/cuda-repository-pin-600
wget https://developer.download.nvidia.com/compute/cuda/12.4.0/local_installers/cuda-repo-ubuntu2204-12-4-local_12.4.0-550.54.14-1_amd64.deb
sudo dpkg -i cuda-repo-ubuntu2204-12-4-local_12.4.0-550.54.14-1_amd64.deb
sudo cp /var/cuda-repo-ubuntu2204-12-4-local/cuda-*-keyring.gpg /usr/share/keyrings/
sudo apt-get update`,
    },
    {
      title: "Step 2: Enable Ubuntu 20.04 (Focal) Repositories",
      command: `echo "deb http://archive.ubuntu.com/ubuntu focal main universe" | sudo tee /etc/apt/sources.list.d/focal.list
sudo apt update`,
    },
    {
      title: "Step 3: Install Dependencies",
      command: `sudo apt install -y libtinfo5`,
    },
    {
      title: "Step 4: Install CUDA Toolkit",
      command: `sudo apt-get -y install cuda-toolkit-12-4`,
    },
    {
      title: "Step 5: Verify Installation",
      command: `echo $PATH | grep cuda
ls /usr/local/`,
    },
    {
      title: "Step 6: Set Environment Variables",
      command: `echo 'export PATH=/usr/local/cuda-12.4/bin:$PATH' >> ~/.bashrc
echo 'export LD_LIBRARY_PATH=/usr/local/cuda-12.4/lib64:$LD_LIBRARY_PATH' >> ~/.bashrc
source ~/.bashrc
nvcc --version`,
    },
    {
      title: "Step 7: Set Up Python Virtual Environment & Install PyTorch",
      command: `sudo apt install -y python3.12-venv
python3 -m venv venv
source venv/bin/activate
pip install torch torchvision torchaudio --index-url https://download.pytorch.org/whl/cu124
deactivate`,
    },
    {
      title: "Step 8: Install PyTorch Again (Optional if needed again)",
      command: `ssource venv/bin/activate
pip install torch torchvision torchaudio --index-url https://download.pytorch.org/whl/cu124
deactivate`,
    },
    {
      title: "Step 9: Create and Run Python Test Script",
      command: `sudo nano test.py`,
      code: `import torch
print(f'PyTorch version: {torch.__version__}')
print(f'CUDA Available: {torch.cuda.is_available()}')
print(f'Number of GPUs: {torch.cuda.device_count()}')
if torch.cuda.is_available():
    print(f'Current Device: {torch.cuda.current_device()}')
    print(f'Device Name: {torch.cuda.get_device_name(torch.cuda.current_device())}')
print(torch.backends.cudnn.enabled)
print(torch.version.cuda)" > test.py`,
      postCommand: `source venv/bin/activate
python3 test.py
deactivate`,
    },
    {
      title: "Step 10: Install Conda & CUDA Toolkit via Conda (If Needed)",
      command: `wget https://repo.anaconda.com/archive/Anaconda3-2024.10-1-Linux-x86_64.sh
bash Anaconda3-2024.10-1-Linux-x86_64.sh -b -p $HOME/anaconda3
export PATH="$HOME/anaconda3/bin:$PATH"
source ~/.bashrc

conda install -y conda-forge::cudatoolkit-dev
conda create -y -n envname python=3.10
conda activate envname
pip install torch torchaudio torchvision
echo "CUDA setup complete!"`,
    },
    {
      title: "Do's & Don'ts",
      content: `Never Ever run "sudo reboot" "sudo apt upgrade" and "sudo apt install -y nvidia-utils-X" and "apt install -y nvidia-toolkit-X" , Any Kind of Desktop Environment or uninstalling/installing the NVIDIA Drivers in containers.`,
    },
  ];

  return (
    <>
    <Nav/>
        <div className='main-container'>

     <div className="banner">
                    <img className="background" src={banner} alt="" />
                <h1 className="main-heading-title">Manuals</h1>
        
                </div>
    <div className="gpu-guide-container">
      <h1>GPU Setup Instructions</h1>

      <h2 className="start-list">Getting Started</h2>
      <ol>
        {gettingStart.map((step, index) => {
          const subStepIndices = [3, 4, 5];

          return subStepIndices.includes(index) ? (
            <li key={index} className="start-sub-steps">
              {step}
            </li>
          ) : (
            <li key={index} className="start-steps">
              {step}
            </li>
          );
        })}
      </ol>
      <h2 className="start-list">
        GPU Container CUDA and Pytorch Installation and Do’s & Don’ts
      </h2>
      <p
        style={{
          color: "#163154ff;",
          textDecoration: "underline",
          fontWeight: 700,
        }}
      >
        Installation and Environment Creation
      </p>

      <ol className="gpu-guide-list">
        {steps.map((step, index) => (
          <li key={index} className="gpu-step">
            <h2>{step.title}</h2>

            {step.content &&
              (step.title !== "Do's & Don'ts" ? (
                <p className="gpu-text-block">{step.content}</p>
              ) : (
                <p className="gpu-note-block">{step.content}</p>
              ))}

            {step.command && (
              <div className="gpu-code-block">
                <pre>{step.command}</pre>
              </div>
            )}

            {step.code && (
              <div className="gpu-code-block">
                <pre>{step.code}</pre>
              </div>
            )}

            {step.postCommand && (
              <div className="gpu-code-block">
                <pre>{step.postCommand}</pre>
              </div>
            )}
          </li>
        ))}
      </ol>
    </div>
    </div>
    <Footer/>
    </>
  );
};

export default Manuals;
